import C from '../constants';
import {combineReducers} from 'redux'

const session = (state = {}, action) => {
    switch (action.type) {
        case C.UPDATE_SESSION:
            const newSession = {...state};
            Object.keys(action.payload).forEach(k => newSession[k] = action.payload[k]);
            return newSession;
        case C.SET_USER_AGE:
            const newSessionA = {...state};
            newSessionA.age = action.payload;
            return newSessionA;
        case C.SET_USER_SEX:
            const newSessionS = {...state};
            newSessionS.sex = action.payload;
            return newSessionS;
        case C.USER_AGREE:
            const newState = {...state};
            newState.userAgree = action.payload;
            return newState;
        case C.REQUIRE_CONTACT:
            const newStateC = {...state};
            newStateC.requireContact = action.payload;
            return newStateC;
        case C.RESET:
            const newStateR = {...state};
            newStateR.userAgree = newStateR.requireContact = false;
            return newStateR;
        case C.RESET_HARD:
            return {
                "username": "",
                "email": "",
                "phone": "",
                "message": "",
                "age": 0,
                "sex": "",
                "userAgree": false,
                "requireContact": false
            };
        default:
            return state;
    }
};

const awsTestRecordId = (state = "", action) => {
    switch (action.type) {
        case C.SET_RECORD_ID:
            return action.payload;
        case C.RESET:
        case C.RESET_HARD:
            return "";
        default:
            return state;
    }
};

const testData = (state = {}, action) => {
    switch (action.type) {
        case C.USER_AGREE:
            const newStateA = {...state};
            newStateA.timeStarted = Date.now();
            return newStateA;
        case C.SET_CURRENT_QUESTION:
            const newState = {...state};
            newState.currentQId = action.payload;
            return newState;
        case C.SET_SHOW_TEST:
            const newStateT = {...state};
            newStateT.showTest = action.payload;
            return newStateT;
        case C.SET_SHOW_RESULTS:
            const newStateSh = {...state};
            newStateSh.showResults = action.payload;
            return newStateSh;
        case C.RESET:
        case C.RESET_HARD:
            const newStateR = {...state};
            newStateR.timeStarted = 0;
            newStateR.currentQId = 0;
            newStateR.showTest = false;
            newStateR.showResults = false;
            return newStateR;
        default:
            return state;
    }
};

const questions = (state = [], action) => {
    switch (action.type) {
        case C.SET_QUESTION_RESULT:
            return state.filter(q => q.id !== action.payload.id).concat([action.payload]);
        case C.RESET:
        case C.RESET_HARD:
            return state.map(q => {
                const newQ = {...q};
                newQ.result = -1;
                return newQ;
            });
        default:
            return state;
    }
};

const errors = (state = [], action) => {
    switch (action.type) {
        case C.ADD_ERROR:
            console.log("Add error", state, action);
            return [...state, action.payload];
        case C.CLEAR_ERROR:
            return state.filter((message, i) => i !== action.payload);
        case C.RESET:
        case C.RESET_HARD:
        case C.CLEAR_ALL_ERRORS:
            return [];
        default :
            return state
    }
};

export const isProcessing = (state = false, action) => {
    switch (action.type) {
        case C.PROCESSING:
            return action.payload;
        case C.RESET:
        case C.RESET_HARD:
            return false;
        default:
            return state;
    }
};

export default combineReducers({
    session,
    awsTestRecordId,
    testData,
    questions,
    errors,
    isProcessing
});